import { UseMutationOptions, UseQueryOptions } from "@tanstack/react-query";
import { ITenantProfile, TenantProfileRequest } from "../library/models/tenantProfile";
import { BaseService } from "./baseService";

/**
 * The clinic's own presentation copy, as shown on About.
 *
 * Neither call names a clinic: the API takes it from the session, so this returns the
 * caller's own profile and writes to nobody else's. Reading needs any signed-in member;
 * writing is the clinic admin's alone, and the API answers 403 either way rather than
 * trusting the button to have been hidden.
 */
export class TenantProfileService extends BaseService {
    getTenantProfile(): UseQueryOptions<ITenantProfile, Error> {
        return this.createGetQuery<ITenantProfile>('/tenant-profile');
    }

    /**
     * Sends the whole page, not a patch: whatever is absent is removed, and the order of
     * each card list is the order it is drawn in. Hand-written rather than built with
     * createMutation, which only speaks POST/PATCH/DELETE shapes.
     *
     * Resolves with the stored result, so the caller can render what was actually saved
     * instead of trusting its own draft.
     */
    saveTenantProfileMutation(): UseMutationOptions<ITenantProfile, Error, TenantProfileRequest> {
        return {
            mutationFn: (payload: TenantProfileRequest): Promise<ITenantProfile> =>
                this.put<ITenantProfile>('/tenant-profile', payload),
        };
    }
}
